import {Player} from '@/models/Player';
import {Registered} from '@/Manager';
import manager from '@/Manager/Manager';

export class Equipe extends Registered {
	
	private _players: Player[] = [];
	private _score: number = 0;
	
	
	public get players(): Player[] {
		return this._players;
	}
	
	public addPlayer(player: Player): this {
		this._players.push(player);
		return this;
	}
	
	public get score(): number {
		return this._score;
	}
	
	public set score(value: number) {
		this._score = value;
	}
	
	public toJSON(): any {
		return {
			__className__: 'Equipe',
			score: this._score,
			players: this._players.map(m => m.id),
		};
	}
	
	public fromJSON(data: any): this {
		this._score = data.score;
		this._players = <Player[]>data.players.map(id => manager.find(id));
		return this;
	}
}